import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import Vuetify from 'vuetify/lib'
import VueAnalytics from 'vue-analytics'
import PrismicVue from 'prismic-vue'
import linkResolver from './link-resolver'
import htmlSerializer from './htmlSerializer'

// import external stylesheets
import 'font-awesome/css/font-awesome.min.css'
import 'vuetify/dist/vuetify.min.css'

import vuetify from './plugins/vuetify'

Vue.use(Vuetify, {
  theme: {
    primary: '#236365'
  }
})
Vue.use(VueAnalytics, {
  id: 'UA-138497758-2',
  router,
  ignoreRoutes: ['admin'],
  disabled: true
})

Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
  htmlSerializer
})
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
